import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function EventLink({ link }) {
  return (
    <div className="evlink">
      <span>Länk:</span>
      <Link to={link} rel="preload" target="_blank">
        {link}
      </Link>
    </div>
  );
}

EventLink.propTypes = {
  link: PropTypes.string.isRequired
};
